import React from 'react';
import { TypedMemo } from '../../common/types';
import { useWorkspaceChangeReset } from '../session/useWorkspaceChangeReset';

const WorkspaceChangeResetComponent: React.FC = () => {
  useWorkspaceChangeReset();
  return null;
};

/** Resets the caches when the session token names another workspace. Render it after the app tree. */
export const WorkspaceChangeReset = TypedMemo(WorkspaceChangeResetComponent);
